import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import { API_BASE, request, withEntityIds } from '../services/http';

const bestGoodsAdapter = createEntityAdapter();

const initialState = bestGoodsAdapter.getInitialState({
    bestGoodsLoadingStatus: 'idle'
});

export const fetchBestGoods = createAsyncThunk(
    'bestGoods/fetchBestGoods',
    async () => withEntityIds(await request(`${API_BASE}/best`))
);

const bestGoodsSlice = createSlice({
    name: 'bestGoods',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBestGoods.pending, (state) => {
                state.bestGoodsLoadingStatus = 'loading';
            })
            .addCase(fetchBestGoods.fulfilled, (state, action) => {
                state.bestGoodsLoadingStatus = 'succeeded';
                bestGoodsAdapter.setAll(state, action.payload);
            })
            .addCase(fetchBestGoods.rejected, (state) => {
                state.bestGoodsLoadingStatus = 'error';
            });
    }
});

export default bestGoodsSlice.reducer;

export const { selectAll } = bestGoodsAdapter.getSelectors((state) => state.bestGoods);
